var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('load-profile'),_c('div',{staticClass:"mb-2 sub-menu"},_vm._l((_vm.menus),function(menu){return (_vm.$can('read', menu.resource))?_c('b-button',{key:("menu-" + (menu.routeName)),staticClass:"mr-1",attrs:{"id":menu.routeName,"variant":_vm.$route.meta.navActiveTab == menu.active
          ? "primary"
          : "outline-primary"},on:{"click":function($event){return _vm.$router.push({
          name: menu.routeName,
          params: { id: _vm.$route.params.id },
        })}}},[_vm._v(" "+_vm._s(_vm.$t(menu.label))+" ")]):_vm._e()}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }